module.exports = __webpack_public_path__ + "media/images/pic/timeline-f87e8d23ddc7e0e6680bf166b94e80b1.jpg";